<template>
  <el-container class="container">
    <el-header height="auto">
      <headerNode />
    </el-header>
    <el-main>
      <div class="contentContainer">
        <van-notice-bar v-if="$store.state.token!=''" left-icon="volume-o" :text="notice" />
        <router-view></router-view>
      </div>
    </el-main>
    <el-footer height="auto">
      <footerMobile class="hidden-sm-and-up mobilefooter" />
    </el-footer>
  </el-container>
</template>
<script>
import footerMobile from '@/components/tab/footerMobile.vue'
import header from '@/components/tab/header.vue'

export default {
  components: {
    footerMobile: footerMobile,
    headerNode: header
  },
  data () {
    return {
      notice: Global.GlobalNotice
    }
  },
  methods: {

  },
  created () {

  }
}
</script>
<style lang="less" scoped>
.van-notice-bar {
  padding-left: 2%;
  padding-right: 2%;
}
.el-header {
  padding: 0;
}
.container {
  height: 100%;
  .contentContainer {
    position: relative;
    .pingl {
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .pingr {
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .mo {
      height: 400px;
    }
  }
  @media screen and(max-width: 768px) {
    .contentContainer {
      overflow: scroll;
    }
  }
  .mobilefooter {
    padding: 0;
    margin: 0px 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue